import React, { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import BookingNotesDrawer from "./BookingNotesDrawer";
import bookingNotesService from "../../../services/bookingNotesService";

function getLoggedInDisplayName(internalUserData, agentProfile) {
  return (
    internalUserData?.name ||
    internalUserData?.username ||
    agentProfile?.userId ||
    ""
  );
}

function BookingNotesTrigger({ pnr }) {
  const { t } = useTranslation();
  const agentProfile = useSelector((state) => state.agentProfile);
  const isInternalUserAutheticated = useSelector(
    (state) => state.internalUser.isInternalUserAutheticated
  );
  const internalUserData = useSelector(
    (state) => state.internalUser.internalUserData
  );
  const currentUserName = getLoggedInDisplayName(internalUserData, agentProfile);
  const [open, setOpen] = useState(false);
  const [count, setCount] = useState(0);

  const refreshCount = useCallback(async () => {
    if (!pnr || !isInternalUserAutheticated) {
      setCount(0);
      return;
    }
    try {
      const notes = await bookingNotesService.getNotes(pnr);
      setCount(notes.length);
    } catch (err) {
      setCount(0);
    }
  }, [pnr, isInternalUserAutheticated]);

  useEffect(() => {
    refreshCount();
  }, [refreshCount]);

  if (!pnr || !isInternalUserAutheticated) {
    return null;
  }

  return (
    <>
      <button
        type="button"
        className="bd-notes-trigger"
        onClick={() => setOpen(true)}
      >
        <i className="far fa-sticky-note" aria-hidden="true"></i>
        <span>{t("Notes")}</span>
        {count > 0 ? <span className="bd-notes-trigger-count">{count}</span> : null}
      </button>
      <BookingNotesDrawer
        open={open}
        onClose={() => setOpen(false)}
        pnr={pnr}
        currentUserId={currentUserName}
        onNotesChange={setCount}
      />
    </>
  );
}

export default BookingNotesTrigger;
